export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14886.aa697217.jpg";